import { useState } from 'react';
import { useAddRawContactMutation as useAddRawContactRTK } from '../../../../../services/cellcast.v2';
import { toast } from 'react-toastify';
import { useI18n } from '../../../../Utils/_helpers/useI18n';
import { AddContactResponse } from '../type';

// Create a proper interface for the add contact request
export interface AddContactPayload {
  fullName: string;
  email?: string;
  phone?: string;
  source: string;
  cardId?: string;
  cardName?: string;
}

// This is a custom wrapper around the RTK query hook that adapts the payload
export const useContactAdd = (onSuccess?: () => void) => {
  const [isAdding, setIsAdding] = useState(false);
  const [addRawContact] = useAddRawContactRTK();
  const { t } = useI18n();

  const handleAddContact = async (ids: string[]) => {

    try {
      setIsAdding(true);
      const response: AddContactResponse = await addRawContact({ ids: ids }).unwrap();
      const message = response?.message;
      if (!response.status) {
        toast.error(message);
        return false;
      }
      toast.success(message);
      
      // Call success callback if provided
      if (onSuccess) {
        onSuccess();
      }
      
      return true;
    } catch (error: any) {
      // Handle error
      toast.error(error?.data?.message || t('RAW_CONTACT_COLLECTION.ADD_ERROR'));
      return false;
    } finally {
      setIsAdding(false);
    }
  };

  return {
    handleAddContact,
    isAdding
  };
};
